/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { citasConfirmacionControllerActualizarCitaConfirmacion } from '../fn/citas-confirmacion/citas-confirmacion-controller-actualizar-cita-confirmacion';
import { CitasConfirmacionControllerActualizarCitaConfirmacion$Params } from '../fn/citas-confirmacion/citas-confirmacion-controller-actualizar-cita-confirmacion';
import { citasConfirmacionControllerGetCita } from '../fn/citas-confirmacion/citas-confirmacion-controller-get-cita';
import { CitasConfirmacionControllerGetCita$Params } from '../fn/citas-confirmacion/citas-confirmacion-controller-get-cita';

@Injectable({ providedIn: 'root' })
export class CitasConfirmacionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `citasConfirmacionControllerGetCita()` */
  static readonly CitasConfirmacionControllerGetCitaPath = '/api/citas-confirmacion/{uuidCita}';

  /**
   * Obtener cita.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `citasConfirmacionControllerGetCita()` instead.
   *
   * This method doesn't expect any request body.
   */
  citasConfirmacionControllerGetCita$Response(params: CitasConfirmacionControllerGetCita$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return citasConfirmacionControllerGetCita(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener cita.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `citasConfirmacionControllerGetCita$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  citasConfirmacionControllerGetCita(params: CitasConfirmacionControllerGetCita$Params, context?: HttpContext): Observable<void> {
    return this.citasConfirmacionControllerGetCita$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `citasConfirmacionControllerActualizarCitaConfirmacion()` */
  static readonly CitasConfirmacionControllerActualizarCitaConfirmacionPath = '/api/citas-confirmacion/{uuidCita}/{idSelene}';

  /**
   * Actualizar confirmación de cita.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `citasConfirmacionControllerActualizarCitaConfirmacion()` instead.
   *
   * This method doesn't expect any request body.
   */
  citasConfirmacionControllerActualizarCitaConfirmacion$Response(params: CitasConfirmacionControllerActualizarCitaConfirmacion$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return citasConfirmacionControllerActualizarCitaConfirmacion(this.http, this.rootUrl, params, context);
  }

  /**
   * Actualizar confirmación de cita.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `citasConfirmacionControllerActualizarCitaConfirmacion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  citasConfirmacionControllerActualizarCitaConfirmacion(params: CitasConfirmacionControllerActualizarCitaConfirmacion$Params, context?: HttpContext): Observable<void> {
    return this.citasConfirmacionControllerActualizarCitaConfirmacion$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
